<style>
    .foo {
        background: #e7e7e7;
    }

    th .status-column-style {
        max-width: 60px;
    }
</style>
<template>
    <div>
        <div class="foo row">
            <ul class="nav nav-pills">
                <li class="disabled"><h4 style="margin-left:15px; margin:10px" class="text-primary"><b>Carehome MAR Status</b></h4></li>
            </ul>
        </div>
        <br />
        <div class="row">
            <div class="col-xs-6 col-md-4">
                <div class="form-group">
                    <label class="control-label" for="focusedInput" style="margin-left:5px">Care home</label>
                    <CarehomeSelector class="form-control" v-model="carehome" :initialid="carehomeid"></CarehomeSelector>
                </div>
            </div>

            <div class="col-xs-6 col-md-4 ">
                <div class="form-group">
                    <label class="control-label" for="focusedInput" style="margin-left:5px">Ward</label>
                    <WardComboSelector :carehome="carehome" v-model="ward"></WardComboSelector>
                </div>
            </div>
            <div class="col-xs-6 col-md-4">
                <div class="form-group">
                    <label class="control-label" for="focusedInput" style="margin-left:5px">MAR Date</label>
                    <simpledatepicker v-model="selectedDate"></simpledatepicker>
                </div>
            </div>

        </div>
        <div class="row" v-if="!controller.CarehomeHub.IsConnected">
            <div class="col-sm-12">
                <div class="well well-sm clearfix">
                    <span v-if="controller.CarehomeHub.IsConnecting" class="text-center"><i class="fa fa-circle faa-pulse animated text-warning"></i> Uh Oh! Disconnected. Trying to reconnect</span>
                    <span v-else class="text-center">
                        <i class="fa fa-exclamation-triangle  text-danger"></i> Hmmm! There seems to be an issue updating MAR Status.
                        <span class="pull-right"><a class="btn btn-primary btn-xs" @click.self="InitializeController">Refresh</a></span>
                    </span>
                </div>
            </div>
        </div>
        <transition name="fade" :duration="1000">
            <div v-show="controller.IsLoading" class="row" style="width:100%; position:absolute;text-align:center; vertical-align:central">
                <br /><br /><br />
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </transition>
        <div v-if="controller">
            <div v-if="!isLoading && controller.Patients.length > 0" class="table-responsive">
                <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th width="200">Name</th>
                            <th width="150">Dob</th>
                            <th width="100" class="text-center" v-for="(group, index) of controller.Groups" v-bind:style="{'font-size': (index==controller.CurrentGroupIndex ? '16px' : ''), 'font-weight': (index==controller.CurrentGroupIndex ? '800' : ''), 'background': (index == controller.CurrentGroupIndex ? '#8bc3f37a' : '')}">

                                <i v-if="index==controller.CurrentGroupIndex" class="fa fa-circle text-success"></i>   {{group.medRoundGroupName}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in controller.PatientRounds" v-bind:style="{'background': (item.IsActive ? '#8bc3f37a' : '')}">
                            <td>
                                <span v-bind:style="{'font-size': (item.IsActive  ? '16px' : ''), 'font-weight': (item.IsActive  ? '800' : '')}"><i v-if="item.IsActive" class="fa fa-circle-o-notch fa-spin text-success"></i> {{ item.Patient.firstName }} {{ item.Patient.lastName }}</span></br>
                                <div v-if="item.IsActive"><small>Carer: {{item.Nurse}}</small></div>
                                <div v-else><small v-if="item.latestMARUser">Carer: {{item.latestMARUser}} ({{formatTime(item.latestMedAdminDateTime)}})</small></div>
                            </td>
                            <td>{{ formatDate(item.Patient.dob)}}</td>
                            <td class="text-center" v-for="(round, key, index) of item.Rounds" v-bind:style="{'background': (index==controller.CurrentGroupIndex ? '#8bc3f37a' : '')}">
                                <a data-toggle="tooltip" data-placement="top" :title="statusText(round.MedRoundGroup.medRoundGroupStatus)">
                                    <DispensationStatusIcon :group="round.MedRoundGroup" :changed-recently="round.RecentlyChanged" />
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="alert alert-warning" v-if="!controller.IsLoading && controller.Patients.length == 0">
                <h4>No records!</h4>
            </div>
        </div>
    </div>
</template>


<script>
    import datatable from "../../corecontrols/datatable/datatable.scp.html";
    import simpledatepicker from "../../corecontrols/simpledatepicker/simpledatepicker.scp.html";
    import CarehomeSelector from "../../appcontrols/carehomeselector/carehomeselector.scp.html";
    import WardComboSelector from "../../appcontrols/wardComboSelector/wardComboSelector.scp.html";

    import CarehomeSelector from "../../appcontrols/carehomeselector/carehomeselector.scp.html";

    import { CarehomeDto } from './../../../dto/carehomedto'
    import { UserDto, UserPermissionDto, DispensationRoundGroup } from "./../../../dto/Dtos";
    import { PatientDto } from "./../../../dto/PatientDto";
    import Dal from './../../../scripts/dataaccess'
    import Formatter from "../../corecontrols/formatters/Formatter"
    import moment from "moment";
    import DispensationStatusIcon from "../../appcontrols/dispensationStatusIcon/dispensationStatusIcons.scp.html"
    //import toastr from '../../../components/helpers/Toaster'
    ////import faa from 'font-awesome-animation'
    //import CarehomeHub from "./CarehomeHub";

    import CarehomeDispensationController from "./CarehomeDispensationController"

    export default {
        props: {
            carehomeid: {
                type: String,
                required: false
            }
        },
        watch: {
            carehome() {
                console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>Selected Carehome changed", this.carehome)
                this.InitializeController();

            },
            selectedDate() {
                console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>Selected Date changed", this.selectedDate)
                this.InitializeController();
            },

            ward() {

                console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>Selected Ward changed", this.ward)
                this.InitializeController();
            }

        },
        data: function () {
            var formatDate = Formatter.FormatDate;
            var that = this;
            return {

                carehome: {},
                ward: {},
                selectedDate: new Date(),

                currentGroup: 2,
                isLoading: false,
                controller: new CarehomeDispensationController()
            }
        },
        //mounted: function () {
        //    console.log("Carehome Dispensation mounted with ", this.carehomeid)

        //    //console.log("Carehome Dispensation loading hub")

        //    //var hub = new CarehomeHub(this.UpdateCarehome);

        //    //console.log("Carehome Dispensation loaded hub")
        //},
        beforeDestroy: function () {
            console.log("Cleaning up Carehome Dispensation");
            this.controller.dispose();
        },

        methods: {
            InitializeController() {
                if (this.carehome && this.selectedDate) {
                    //this.controller = new CarehomeMarController(this.carehome.id, this.selectedDate)
                    this.controller.Initialize(this.carehome.id, this.ward.id, this.selectedDate);
                }
            },

            formatDate: function (dt) {
                return Formatter.FormatDate(dt);
            },

            formatTime: function (dt) {
                return Formatter.FormatTime(dt);
            },
            statusText: function (status) {
                if (status == 0) {
                    return 'No Administration'
                }
                else if (status == 15) {
                    return 'Administration Skipped'
                }
                else if (status == 25) {
                    return 'All Medicines Taken'
                }
                else if (status == 35) {
                    return 'Administration Pending'
                }
                return 'Administration Missed';
            }
        },
        components: {
            datatable,
            Formatter,
            simpledatepicker,
            CarehomeSelector,
            DispensationStatusIcon,
            WardComboSelector
        }
    }
</script>



// WEBPACK FOOTER //
// carehome-dispensation.scp.html?6e382aae